import type {
    CompRef,
    OverrideOrDefaultData,
    PossibleViewModes,
    Pointer,
    PopulatedComponentContainerInfoMap
} from '@wix/document-services-types'
import _ from 'lodash'

type SlotsData = {slots?: Record<string, string>} | void

export const createContainerInfoMapFromSlotsData = (
    slotsData: SlotsData,
    manifestContainersList: OverrideOrDefaultData[],
    getPointer: (id: string, type: PossibleViewModes) => Pointer,
    compRefType: PossibleViewModes
): PopulatedComponentContainerInfoMap =>
    _.reduce(
        slotsData?.slots,
        (result, compId, slotKey) => {
            const containerItem = _.find(manifestContainersList, item => item.value === slotKey)
            result[compId] = {
                compRef: getPointer(_.trimStart(compId, '#'), compRefType) as CompRef,
                nestedDataPath: containerItem?.nestedDataPath ?? [],
                slotName: containerItem?.prop ?? slotKey
            }
            return result
        },
        {} as PopulatedComponentContainerInfoMap
    )
